<script>
import appConfig from "@/app.config";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "Résultat non trouvé",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout
  },
}
</script>

<template>
  <Layout>
    <div class="account-pages my-5 pt-5" style="min-height: 70vh;">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8 text-center">
            <div class="error-container">
              <!-- Animated 404 Text -->
              <div class="error-code  ">
                <span class="animated fadeIn delay-03s">4</span><span class="text-primary animated fadeIn delay-06s">0</span><span class=" animated fadeIn delay-1s">4</span>
              </div>

              <h3 class="text-primary text-uppercase mt-4 animated fadeIn delay-1s">
                Oups ! Page non trouvée
              </h3>

              <h4 class="text-secondary mt-3 animated fadeIn delay-1p5s">
                Désolé, la page que vous cherchez semble introuvable.
              </h4>

              <div class="animated fadeIn delay-2s">
                <img src="@/assets/images/404-illustration.svg" alt="404 Illustration" class="img-fluid" style="max-width: 500px;">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.error-container {
  padding: 40px;
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.error-code {
  font-size: 120px;
  font-weight: bold;
  color: #2c3e50;
  line-height: 1;
}

.animated {
  animation-duration: 1s;
  animation-fill-mode: both;
}

.fadeIn {
  animation-name: fadeIn;
}

.delay-03s {
  animation-delay: 0.33s;
}
.delay-06s {
  animation-delay: 0.66s;
}
.delay-1s {
  animation-delay: 1s;
}

.delay-1p5s {
  animation-delay: 1.5s;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.btn-primary {
  background-color: #3b7ddd;
  border-color: #3b7ddd;
  padding: 10px 30px;
  font-size: 16px;
  border-radius: 50px;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  background-color: #2c6ac7;
  border-color: #2c6ac7;
  transform: translateY(-2px);
}

.img-fluid {
  max-width: 100%;
  height: auto;
}
</style>